import { render, staticRenderFns } from "./OrderItemListDetail.vue?vue&type=template&id=2faf8923&scoped=true"
import script from "./OrderItemListDetail.vue?vue&type=script&lang=js"
export * from "./OrderItemListDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderItemListDetail.vue?vue&type=style&index=0&id=2faf8923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf8923",
  null
  
)

export default component.exports